"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortOptionsForSearch = exports.alphaSortOptions = void 0;
var matchesStart = function matchesStart(value, search) {
  return value.toLowerCase().startsWith(search.toLowerCase());
};
var alphaSortOptions = function alphaSortOptions(a, b) {
  return a.label.localeCompare(b.label);
};
exports.alphaSortOptions = alphaSortOptions;
var sortOptionsForSearch = function sortOptionsForSearch(a, b, search) {
  if (matchesStart(a.label, search) && matchesStart(b.label, search)) {
    return alphaSortOptions(a, b);
  }
  if (matchesStart(a.label, search)) {
    return -1;
  }
  if (matchesStart(b.label, search)) {
    return 1;
  }
  return alphaSortOptions(a, b);
};
exports.sortOptionsForSearch = sortOptionsForSearch;